import { render, staticRenderFns } from "./statisticValue.vue?vue&type=template&id=4b5b8866&scoped=true"
import script from "./statisticValue.vue?vue&type=script&lang=js"
export * from "./statisticValue.vue?vue&type=script&lang=js"
import style0 from "./statisticValue.vue?vue&type=style&index=0&id=4b5b8866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b8866",
  null
  
)

export default component.exports